<template>
  <header class="header">
    <nav class="nav clearfix">
      <a
        href="#/home"
        class="home-logo"
      >
        <img
          src="@/assets/images/logo.png"
          alt=""
        >
      </a>
      <ul>
        <li :class="isHome ? 'active' : ''"><a href="#/">首页</a></li>
        <li v-for="item in channelList" :key="item.id" :class="isActive(item.id)"><router-link :to="{path:'/news',query:{channelId: item.id}}"><a href="#/news">{{item.channelName}}</a></router-link></li>
        <li><a href="#/dashboard">管理后台</a></li>
        <li class="fr" v-if="isLogin"><a href="#/login">登录</a></li>
      </ul>
    </nav>
  </header>
</template>

<script>
import store from '@/store'
import { getChannelList } from '@/api/channel'
export default {
  data() {
    return {
      isLogin: true,
      channelList: []
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    isHome() {
      return this.routeName === 'home'
    }
  },
  methods: {
    // 栏目导航列表
    getChannelListData() {
      getChannelList({
        page: 1,
        size: 100
      }).then(res => {
        this.channelList = res.data.rows.filter(item => {
          return item.isNavigation === 1
        })
      })
    },
    isActive(id) {
      if (this.$route.query.channelId === id) {
        return 'active'
      }
    }
  },
  created() {
    if (store.state.token) {
      this.isLogin = false
    }
  },
  mounted() {
    this.getChannelListData()
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 60px;

  .home-logo {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 60px;
    height: 60px;
    text-align: center;

    img {
      width: 60px;
    }
  }

  .nav {
    padding-left: 100px;
    position: relative;
    width: 1200px;
    margin: 0 auto;
  }

  ul li {
    float: left;
    width: 120px;
    height: 60px;
    line-height: 60px;
    position: relative;
    text-align: center;

    &::after {
      content: ' ';
      display: none;
      width: 100%;
      height: 2px;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #3b78e7;
    }

    &.active,
    &:hover {
      &::after {
        display: block;
      }

      a {
        color: #3b78e7;
      }
    }

    a {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      color: #333333;
    }
  }
}
</style>
